exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".item-image img[data-v-b6161a6e]{max-width:63px}.item-image[data-v-b6161a6e]{min-height:73px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex}.column.is-6.py-0[data-v-b6161a6e]{padding-top:0;padding-bottom:0}.text-sm[data-v-b6161a6e]{font-size:13px}", ""]);

// exports
